'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.parseCoordinates = parseCoordinates;

function parseCoordinates(a) {
  return a.coordinates ? parseInfoboxCoords(a.coordinates) : a.latd && a.longd ? parseDeprecatedCoords(a) : {
    lat: null,
    lon: null,
    error: 'No coordinates on page.'
  };
}

function parseDeprecatedCoords(a) {
  var b = dmsToDecimal(floatOrDefault(a.latd), floatOrDefault(a.latm), floatOrDefault(a.lats), a.latNs),
      c = dmsToDecimal(floatOrDefault(a.longd), floatOrDefault(a.longm), floatOrDefault(a.longs), a.longEw);
  return wikiCoordinates(b, c);
}

var infoboxCoordinatePattern = /(\d{1,2})\|(\d{1,2})\|(\d{1,2})?\|?([NSEW])\|(\d{1,3})\|(\d{1,2})\|(\d{1,2})?\|?([NSEW])/;

function parseInfoboxCoords(a) {
  var b, c, d;
  return b = a.match(infoboxCoordinatePattern), c = convertCoordinatesFromStrings(b.slice(0, 4)), d = convertCoordinatesFromStrings(b.slice(4)), wikiCoordinates(c, d);
}

function convertCoordinatesFromStrings(a) {
  return dmsToDecimal(floatOrDefault(a[1]), floatOrDefault(a[2]), floatOrDefault(a[3]), a[4]);
}

var directions = {
  N: 1,
  S: -1,
  E: 1,
  W: -1
};

function dmsToDecimal(a, b, c, d) {
  return (a + 1 / 60 * b + 1 / 3600 * c) * (directions[d] || 1);
}

function wikiCoordinates(a, b) {
  return {
    lat: +a.toFixed(4),
    lon: +b.toFixed(4)
  };
}

function floatOrDefault(a) {
  var b = +a;
  return isNaN(b) ? 0 : b;
}